export const UPDATE_CUSTOMER_PENDING = 'UPDATE_CUSTOMER_PENDING';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_ERROR = 'UPDATE_CUSTOMER_ERROR';

export const ADD_PAYMENT_START = 'ADD_PAYMENT_START';
export const ADD_PAYMENT_SUCCESS = 'ADD_PAYMENT_SUCCESS';
export const ADD_PAYMENT_ERROR = 'ADD_PAYMENT_ERROR';

export const SET_PAYMENT_METHOD_LOADING = 'SET_PAYMENT_METHOD_LOADING';
export const SET_PAYMENT_METHOD_SUCCESS = 'SET_PAYMENT_METHOD_SUCCESS';
export const SET_PAYMENT_METHOD_ERROR = 'SET_PAYMENT_METHOD_ERROR';

export const SET_PAYMENT_METHOD_DELETE_LOADING = 'SET_PAYMENT_METHOD_DELETE_LOADING';
export const SET_PAYMENT_METHOD_DELETE_SUCCESS = 'SET_PAYMENT_METHOD_DELETE_SUCCESS';
export const SET_PAYMENT_METHOD_DELETE_ERROR = 'SET_PAYMENT_METHOD_DELETE_ERROR';

export const SET_PAYMENT_METHOD_ROLE_LOADING = 'SET_PAYMENT_METHOD_ROLE_LOADING';
export const SET_PAYMENT_METHOD_ROLE_SUCCESS = 'SET_PAYMENT_METHOD_ROLE_SUCCESS';
export const SET_PAYMENT_METHOD_ROLE_ERROR = 'SET_PAYMENT_METHOD_ROLE_ERROR';

export const REFERRAL_ID = 'REFERRAL_ID';
